export const formatServerError = ({ code, message }: { code: number; message: string }): string =>
  `Code: ${code}. Message: ${message}`
